import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { ReportsComponent, ReportsService, RevenueReportComponent, FillReportComponent, FilterItemsService, RecentSavedReportsComponent, InternalFillReportComponent, RejectedRequestsReportComponent, TopCampaignsReportComponent } from "./index";
import { Ng2PaginationModule } from "ng2-pagination";
import { Ng2DatetimePickerModule } from "ng2-datetime-picker/dist";
import { EndpointsService } from "../core/services/index";
import { UniqueUsersReportComponent } from './unique-users-report/unique-users-report.component';
import { PhonePlanBreakdownReportComponent } from './phone-plan-breakdown-report/phone-plan-breakdown-report.component';

@NgModule({
    imports: [CommonModule, SharedModule, Ng2PaginationModule, Ng2DatetimePickerModule],
    exports: [],
    declarations: [
        ReportsComponent,
        RevenueReportComponent,
        FillReportComponent,
        RecentSavedReportsComponent,
        InternalFillReportComponent,
        RejectedRequestsReportComponent,
        TopCampaignsReportComponent,
        UniqueUsersReportComponent,
        PhonePlanBreakdownReportComponent
    ],
    providers: [ReportsService, FilterItemsService, EndpointsService],
})
export class ReportsModule { }



// WEBPACK FOOTER //
// ./src/app/reports/reports.module.ts